// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import cx from 'classnames';
import styles from './FilterPanel.module.scss';
import Icon from 'shared/components/Icon';

/**
 * FilterPanel
 */

/** @typedef {{}} FilterPanelProps */

/** @type { StatelessComponent<FilterPanelProps> } */
export const FilterPanel = ({ children }) => {
  return <div className={cx('FilterPanel', styles.FilterPanel)}>{children}</div>;
};

/**
 * FilterItem
 */

/** @typedef {{
  label: string
}} FilterItemProps */

/** @type { StatelessComponent<FilterItemProps> } */
export const FilterItem = ({ label, children }) => {
  return (
    <div className={cx('FilterItem', styles.FilterItem)}>
      <div className="field">
        <label className={cx('bulma__label', styles.filter_label)}>
          <span style={{ marginRight: '0.25rem' }}>
            <Icon name="filter" />
          </span>
          {label}
        </label>
        <div className={cx('control', styles.FilterItem__control)}>{children}</div>
      </div>
    </div>
  );
};

/**
 * FilterActionContainer
 */

/** @typedef {{}} FilterActionContainerProps */

/** @type { StatelessComponent<FilterActionContainerProps> } */
export const FilterActionContainer = ({ children }) => {
  return (
    <div className={cx('FilterActionContainer', styles.FilterActionContainer)}>{children}</div>
  );
};
